import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYoutubeComponent } from './simple-icons-youtube.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYoutubeComponent ],
    exports:      [ SimpleIconsYoutubeComponent ],
    bootstrap:    []
})
export class SimpleIconsYoutubeModule {}
